import {formatNumber} from '../../../../../components/util'

export function SlideResumoMercado(data, slideT) {
  let tableData = []
  tableData.push([
    {text: '#', options: {color: '333333', align: 'center', bold: true, w: 0.05}},
    {text: 'Produto', options: {color: '333333', align: 'center', bold: true}},
    {text: 'Incorporadora', options: {color: '333333', align: 'center', bold: true}},
    {text: 'Distância', options: {color: '333333', align: 'center', bold: true}},
  ])

  data.sort(function (a, b) {
    return a.distancia - b.distancia
  })
  let count = 1
  // eslint-disable-next-line array-callback-return
  data.map((item, index) => {
    if (!Array.isArray(item)) {
      if (item.computed && !item.removed) {
        if (count <= 15) {
          tableData.push([
            {text: index + 1, options: {color: '333333', align: 'center'}},
            {
              text: item.nome,
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: item.nome_incorporador,
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.distancia), 'inteiro'),
              options: {color: '333333', align: 'center', bold: false},
            },
          ])
        }
        count++
      }
    }
  })

  const slideconfigTable1 = {
    slide: slideT,
    tableData: tableData,
    config: {
      x: 7.8,
      y: 1.4,
      w: 5.2,
      margin: 3,
      fontSize: 10,
      fill: {color: 'ffffff'},
      border: {pt: 1, color: 'd0d0d0'},
    },
  }

  return slideconfigTable1
}
